module.exports = __webpack_public_path__ + "img/quote-about.82e497ce.jpeg";